<template>
  <div class="serverpage">

    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">服务列表</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <div v-if="tabs.length > 0">
      <van-tabs swipe-threshold="2" @click="tabsChange" v-model="indexStr">
        <van-tab v-for="(item, index) in tabs" :title="item.title"></van-tab>
      </van-tabs>
    </div>

    <div class="servebannerbox">
      <div class="search_box1">
        <div class="search_left1">
          <img class="search_icon1" src="/static/sousuoicon.png" />
          <input class="search_input1" placeholder="请输入您要搜索的商品" v-model="inputkeyword" />
        </div>
        <div class="search_text1" @click="search()">搜索</div>
      </div>
    </div>

    <!-- <div class="top_returnbox returnorder">
      <img class="top_return" @click="previousPage()" src="../../../static/fanhui.png" />
      <img class="top_returnindex" src="../../../static/fanhuishouye.png" />
    </div> -->
    <div class="servebannerbox">
      <img class="servebannerimg" src="../../../static/BANNER111.png" />
    </div>
    <div class="serveshaixuanbox">
      <!-- <div class="search_box1">
        <div class="search_left1">
          <img class="search_icon1" src="/static/sousuoicon.png"></img>
          <input class="search_input1" placeholder="请输入您要搜索的商品" v-model="inputkeyword"></input>
        </div>
        <div class="search_text1" @click="search()">搜索</div>
      </div> -->
      <div class="addresstitlebox">
        <div class="addressboxtop" @click="showcitylist">
          <img class="addressiconimg" src="../../../static/dizhi.png" />
          <div class="addressnamet">{{ city ? city : '定位中..' }}</div>
          <img class="addresstitlemore" src="../../../static/shangshaixuan.png" />
        </div>
        <div :class="isMaskHidden ? 'citydetaillist1' : 'citydetaillist'">
          <div class="citylistbox" @click="tap(item)" v-for="(item, index) in cityList">{{ item }}</div>
        </div>
        <!-- <van-dropdown-menu>
          <van-dropdown-item v-model="city" :options="cityList" />
        </van-dropdown-menu> -->
      </div>
      <!-- <div class="addresstitlebox">
        <van-dropdown-menu>
          <van-dropdown-item v-model="value1" :options="paixuList" />
        </van-dropdown-menu>
      </div>
      <div class="addresstitlebox">
        <van-dropdown-menu>
          <van-dropdown-item v-model="value2" :options="option1" />
        </van-dropdown-menu>
      </div> -->

    </div>
    <!-- @click="toDesc(item.id)" -->
    <div class="servebannerbox1" v-for="(item, index) in storeList" @click="toDetail(item.id)">
      <div class="beCareful-titlebox">
        <img class="serverstoreimg" :src="item.thumb_url" />
        <div class="serverrightbox1">
          <div class="serverightname">{{ item.name }}</div>
          <!-- <div class="serverrightnum">333已售</div> -->
          <div class="serverrightaddressbox">
            <div class="addressdeatil">地址：{{ item.address }}</div>
            <div class="addressjuli">{{ item.distance_str }}</div>
          </div>
        </div>
      </div>
      <div class="serverbottom">
        <div class="servertype">{{ item.ser_name }}</div>
        <div class="serverbotright">
          <div class="serveryuanjia">￥{{ item.m_price }}</div>
          <div class="serverxianjia">￥{{ item.price }}</div>
          <div class="serverbotton1">马上下单</div>
        </div>
      </div>
    </div>
    <div @click="getMore()" class='orderList_label more' v-if="storeFlag">查看更多</div>
  </div>
</template>

<script>
import httper from '../../api/http';
// import {
//   Dialog
// } from 'vant';
let geolocation;
export default {
  data() {
    return {
      indexStr: 0,
      city: "中山市", // 用户所在市区,默认为空中山市
      cityStatus: false, // 用户是否手动选择市区,默认为false
      cityList: [], // 接口获取市区列表
      isMaskHidden: true, // 是否隐藏遮盖层,默认为true
      storeFlag: true, // 服务商家列表能否下拉分页,默认为true
      page_size: 20, // 列表每页条数,默认为20
      storeList: [], // 接口获取服务商家列表,默认为空
      storePage: 1, // 服务商家列表当前页数,默认为1
      wechatmesg: {}, //微信参数
      hrefurl: "", //当前页面url
      isLoading: true, //下拉刷新
      show: false,
      isYearInspection: false, //是否有年审服务
      product_name: "",
      product_type: "",
      inputkeyword: "", //搜索
      product_id: "", // 上一页获取服务编号,默认为空
      booking_id: "", // 上一页获取预约状态的服务编号,默认为空
      package_id: "", //上一页获取的用户卡券id, 默认为空
      latitude: "22.610245", // 微信api获取用户当前纬度,默认为空22.51595
      longitude: "113.204500", // 微信api获取用户当前经度,默认为空113.3926
      showpaixu: false,
      value1: 'a',
      value2: 0,
      option1: [{
        text: '全部商品',
        value: 0
      },
      {
        text: '新款商品',
        value: 1
      },
      {
        text: '活动商品',
        value: 2
      },
      ],
      paixuList: [{
        text: '默认排序',
        value: 'a'
      },
      {
        text: '距离优先',
        value: 'b'
      },
      {
        text: '销量优先',
        value: 'c'
      },
      ],
      tabs: [],
      source: ''
    }
  },
  created() {
    this.getwechat({
      url: location.href.split('#')[0]
    })
    this.request("getCityList")
    // 上一页获取服务编号
    if (this.$route.query.product_id) {
      this.product_id = Number(this.$route.query.product_id);
    } else {
      this.product_id = "";
    }
    //上页面获取商品服务名称
    if (this.$route.query.product_name) {
      this.product_name = this.$route.query.product_name;
    } else {
      this.product_name = "";
    }
    //上页面获取商品服务类型
    if (this.$route.query.product_type) {
      this.product_type = this.$route.query.product_type;
    } else {
      this.product_type = "";
    }
    // 上一页获取预约状态的服务编号
    if (this.$route.query.booking_id) {
      this.booking_id = Number(this.$route.query.booking_id);
    } else {
      this.booking_id = "";
    }
    //上一页获取的用户卡券id
    if (this.$route.query.package_id) {
      this.package_id = Number(this.$route.query.package_id);
    } else {
      this.package_id = "";
    }
    if (this.$route.query.isYearInspection) {
      this.isYearInspection = this.$route.query.isYearInspection;
    } else {
      this.isYearInspection = "";
    }
    geolocation = new qq.maps.Geolocation("444BZ-Z34R4-II6UD-DA3KR-P72IF-46FXB", "wechat-map");
    // geolocation = new qq.maps.Geolocation("AF6BZ-EP5KD-4HF46-PXR7T-6XLCK-RVFG6", "tom");
    //geolocation = new qq.maps.Geolocation("444BZ-Z34R4-II6UD-DA3KR-P72IF-46FXB", "wechat-map");
    // this.hrefurl = window.location.href
    // this.request("getWechat", {
    //   url: this.hrefurl
    // })
    if (!sessionStorage.getItem("latitude") || !sessionStorage.getItem("longitude") || !sessionStorage.getItem("city")) {
      this.getWxLocation()
      return
    }
    //获取纬度
    if (sessionStorage.getItem("latitude")) {
      this.latitude = sessionStorage.getItem("latitude")
    }
    //获取经度
    if (sessionStorage.getItem("longitude")) {
      this.longitude = sessionStorage.getItem("longitude")
    }
    //获取城市
    if (sessionStorage.getItem("city")) {
      this.city = sessionStorage.getItem("city")
    }
    //上一页获取城市
    if (this.$route.query.city) {
      this.city = this.$route.query.city;
    }
    console.log("city", this.$route.query.city)



    let requestData = {};
    requestData.product_id = this.product_id;
    requestData.lat = this.latitude;
    requestData.lng = this.longitude;
    requestData.city = this.city;
    requestData.page = this.storePage;
    requestData.page_size = this.page_size;
    this.request("getStoreList", requestData);

  },
  mounted() {
    this.request("productservice", {
      id: this.product_id
    })
  },
  methods: {
    //返回上一页
    pageReturn() {
      this.$router.go(-1)
    },
    //返回首页
    pageToIndex() {
      this.$router.push({
        path: "/"
      })
    },
    // openpaixu() {
    //   this.showpaixu = true
    // },
    // closepaixu() {
    //   this.showpaixu = false
    // },
    showcitylist() {
      this.isMaskHidden = !this.isMaskHidden;
    },
    //搜索
    search() {
      let that = this
      that.pages = 1
      that.storeList = []
      let requestData = {};
      requestData.product_id = this.product_id;
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      requestData.city = this.city;
      requestData.page = this.storePage;
      requestData.page_size = this.page_size;
      requestData.keyword = this.inputkeyword;
      that.request("getStoreList", requestData)
    },
    //获取城市定位
    tap(city) {
      this.city = city;
      this.storePage = 1;
      this.isMaskHidden = true
      this.storeList = []
      let requestData = {};
      requestData.product_id = this.product_id;
      requestData.city = this.city;
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      requestData.page = this.storePage;
      requestData.page_size = this.page_size;
      this.request("getStoreList", requestData);
    },
    //立即下单
    toDetail(storeid) {
      if (this.tabs.length > 0) {

      }
      this.$router.push({
        path: "/offlineserverDetail",
        query: {
          store_id: storeid,
          product_id: this.product_id
        }
      })
    },

    //获取微信配置信息接口
    getwechat(requestData = {}) {
      httper.get("wechat/wechat/sign-package", requestData, res => {
        //wx.ready(() => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表
        });
      })

      //});
    },
    getWxLocation() {
      let that = this
      wx.ready(() => {
        wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            var speed = res.speed; // 速度，以米/每秒计
            var accuracy = res.accuracy; // 位置精度
            that.latitude = latitude;
            that.longitude = longitude;
            sessionStorage.setItem("latitude", latitude)
            sessionStorage.setItem("longitude", longitude)
            var geocoder = new qq.maps.Geocoder();
            var latLng = new qq.maps.LatLng(latitude, longitude);
            //设置服务请求成功的回调函数
            geocoder.setComplete(function (result) {
              that.city = result.detail.addressComponents.city
              sessionStorage.setItem("city", result.detail.addressComponents.city)
            });
            //若服务请求失败，则运行以下函数
            geocoder.setError(function () {

            });
            //对指定经纬度进行解析
            geocoder.getAddress(latLng);
            let requestData = {};
            requestData.product_id = that.product_id;
            requestData.lat = that.latitude;
            requestData.lng = that.longitude;
            requestData.city = that.city;
            requestData.page = that.storePage;
            requestData.page_size = that.page_size;
            that.request("getStoreList", requestData);
          }
        });
      });
    },
    getMyLocation() {
      let that = this;
      var geolocation = new qq.maps.Geolocation(
        "AU7BZ-U52KD-Q5B4P-H46MS-WID3K-SZBRZ",
        "anhutong-web"
      );
      geolocation.getLocation(that.showPosition, that.showErr); //或者用getLocation精确度比较高
    },
    showErr(e) {
      // this.locationCount++
      // if (this.locationCount < 5) {
      //   // this.searchLocation(); //定位失败再请求定位
      this.getMyLocation() //定位失败再请求定位
      // } else {
      //   this.city = '定位失败,手动选择';
      // }

    },
    showPosition(position) {
      this.latitude = position.lat;
      this.longitude = position.lng;
      this.city = position.city;
      let requestData = {};
      requestData.product_id = this.product_id;
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      requestData.city = this.city;
      requestData.page = this.storePage;
      requestData.page_size = this.page_size;
      this.request("getStoreList", requestData);
    },
    //点击切换导航栏指针
    tabsChange(index) {
      let that = this
      this.storeList = []
      this.indexStr = index
      this.storePage = 1
      that.product_id = that.tabs[index].product_id
      let requestData = {};
      requestData.product_id = that.tabs[index].product_id;
      requestData.lat = that.latitude;
      requestData.lng = that.longitude;
      requestData.city = that.city;
      requestData.page = this.storePage;
      requestData.page_size = that.page_size;
      that.request("getStoreList", requestData)
      // let requestData = {
      //   order_status: [],
      //   page: page,
      //   page_size: that.page_size,
      // }
      // this.pages = page


      //that.request('orderList', requestData)
    },
    buttonClickedFun(duration = 0) {
      this.buttonClicked = true;
      return new Promise((resolve, reject) => {
        if (duration && typeof duration === "number") {
          setTimeout(() => {
            this.buttonClicked = false;
          }, duration);
        }
        resolve(true);
      });
    },
    // 如果没有预约状态的服务编号,跳转服务商家详情页.反之跳转店铺详情
    toDesc(storeId) {
      let that = this;
      if (that.isYearInspection) {
        if (this.product_name == '预约年检') {
          this.$router.push({
            path: "/appointmentYearInsp",
            query: {
              store_id: storeId,
              product_id: that.product_id,
              product_name: that.product_name,
              product_type: that.product_type
            }
          })
        } else {
          this.$router.push({
            path: "/yearlyInspection",
            query: {
              store_id: storeId,
              product_id: this.product_id,
              product_name: that.product_name,
              product_type: that.product_type
            }
          })
        }

      } else {
        if (that.booking_id) {
          that.$router.push({
            path: "/serviceDesc",
            query: {
              store_id: storeId,
              product_id: that.product_id,
              // booking_id: that.booking_id,
              package_id: that.package_id
            }
          });
        } else {
          that.$router.push({
            path: "/serviceDesc",
            query: {
              store_id: storeId
            }
          });
        }
      }
    },
    // 调用接口
    request(type = '', requestData = {}) {
      let that = this
      switch (type) {
        // 线下服务列表
        case 'productservice':
          httper.get('store/off-ser', requestData, res => {
            if (res.code == 0) {
              this.tabs = res.data
            } else {
              this.$toast({
                message: res.message || '操作失败',
              });
            }
          }, false)
          break
        // 获取订单信息列表
        case "getStoreList":
          httper.post("store/ser-store-list", requestData, res => {
            that.loads = 1;
            if (res.code == 0 && res.data) {
              //let storeList = [];
              // if (this.target > 1) {
              //   storeList = that.storeList;
              // }
              let storeList = that.storeList;
              that.storeFlag = res.data.length - this.page_size === 0
              if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                  storeList.push(res.data[i]);
                }
                that.storeList = storeList;
              }

              // that.list = [...this.list, ...res.data] //数据拼接,
              // for (let i = 0; i < res.data.length; i++) {
              //   storeList.push(res.data[i]);
              // }
              // that.storeList = storeList;
              // // that.storePage++;
              // that.storeFlag = res.data.length === that.page_size;
            }
            // else {
            //   that.$toast({
            //     message: '暂无相关服务'
            //   })
            // }
          },
            true
          );
          break;
        // 获取城市列表
        case "getCityList":
          httper.get("/index/city-list", requestData, res => {
            // data.storeList = that.storeList
            // for (let i in res.data) data.storeList.push(res.data[i])
            if (res.data.length > 0) {
              that.cityList = res.data;
            }
          }, false);
          break;
      }
    },
    //查看更多
    getMore() {
      let that = this
      if (!that.storeFlag) {
        that.$toast({
          message: '没有更多了'
        })
        return
      }
      //let page = (that.storePage) + 1
      that.storePage += 1
      if (this.tabs.length > 0) {
        // that.tabsChange(that.indexStr, page, false)
        let requestData = {};
        requestData.product_id = that.tabs[that.indexStr].product_id;
        requestData.lat = that.latitude;
        requestData.lng = that.longitude;
        requestData.city = that.city;
        requestData.page = that.storePage;
        requestData.page_size = that.page_size;
        that.request("getStoreList", requestData)
      } else {
        let requestData = {};
        requestData.product_id = that.product_id;
        requestData.lat = that.latitude;
        requestData.lng = that.longitude;
        requestData.city = that.city;
        requestData.page = that.storePage;
        requestData.page_size = that.page_size;
        that.request("getStoreList", requestData)
      }

    },
  }
}
</script>

<style>
.serverpage {
  background-color: #F8F8FA;
  /* position: relative; */
}

.van-dropdown-menu {
  height: auto;
  background-color: inherit;
}

.van-tabs__wrap--scrollable .van-tab {
  min-width: 30%;
  font-size: 18px;
}

.van-tabs__line {
  background-color: #FD8C00;
  height: 4px;
}

.servebannerbox {
  width: 100%;
  background-color: #FFFFFF;
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
}

.serveshaixuanbox {

  width: 100%;
  background-color: #FFFFFF;
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.servebannerbox1 {
  width: 100%;
  background-color: #FFFFFF;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.servebannerimg {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.search_box1 {
  width: 100%;
  height: 38px;
  background-color: #fff;
  display: flex;
  align-items: center;
  /* margin-bottom: 20px; */
}

.search_left1 {
  width: 85%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: #EEEEEE;
  border-radius: 25px;
}

.search_icon1 {
  width: 15px;
  height: 15px;
  margin: 0 10px;
}

.search_input1 {
  border: none;
  font-size: 12px;
  width: 80%;
  height: 90%;
  border-radius: 25px;
  background-color: inherit;
}

.search_text1 {
  font-size: 16px;
  margin-left: 10px;
}

.addresstitlebox {
  /* width: 100%; */
  position: relative;
}

.citydetaillist1 {
  display: none;
}

.citydetaillist {
  background-color: #EEEEEE;
  border-radius: 8px;
  padding: 12px;
  box-sizing: border-box;
  position: absolute;
  top: 26px;
  left: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 320px;
}

.paixubg {
  position: fixed;
  top: 36%;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, .5);
  z-index: 9;
}

.paixubox {
  width: 100%;
  height: 35px;
  background-color: #FFFFFF;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 0 0 8px 8px;
  z-index: 11;
}

.paixutext {
  font-size: 14px;
  margin-bottom: 10px;
}

.paixubox1 {
  display: none;
}

.citylistbox {
  width: calc(33.3% - 5px);
  height: 35px;
  margin: 3px;
  background-color: #fcfcfc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}

.citydetailtext {}

.addressboxtop {

  display: flex;
  align-items: center;
  /* justify-content: center; */

}

.addressiconimg {
  width: 18px;
  height: 18px;
  margin-right: 3px;
}

.addressnamet {
  font-size: 16px;
  color: #FD8C00;
  margin-right: 3px;
}

.shaixuanname {
  font-size: 16px;
  margin-right: 3px;
}

.addresstitlemore {
  width: 16px;
  height: 16px;
}

.serverstoreimg {
  width: 96px;
  height: 96px;
  margin-right: 20px;
  border-radius: 8px;
}

.serverrightbox1 {
  width: calc(100% - 130px);
}

.serverightname {
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: bold;
}

.serverrightnum {
  font-size: 13px;
  margin-bottom: 10px;
}

.serverrightaddressbox {
  /* width: calc(100% - 130px); */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.addressdeatil {
  width: 70%;
  font-size: 14px;
  color: #666666;
}

.addressjuli {
  font-size: 14px;
  color: #FD8C00;
}

.serverbottom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.servertype {
  font-size: 15px;
  font-weight: bold;
}

.serverbotright {
  display: flex;
  align-items: center;
}

.serveryuanjia {
  font-size: 15px;
  color: #BBBBBB;
  margin-right: 18px;
  text-decoration: line-through;
}

.serverxianjia {
  font-size: 15px;
  color: #FF0000;
  margin-right: 38px;
}

.serverbotton1 {
  width: 69px;
  height: 27px;
  background: #FD8C00;
  color: #FFFFFF;
  border-radius: 13px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.returnorder {
  top: 77px;
}

.beCareful-titlebox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.van-tabs__nav {
  background-color: #FFFFFF !important;
}

.van-tabs__line {
  background-color: #FD8C00 !important;
  width: 19px !important;
}

.orderList_label {
  margin: 20px 15px 0;
  display: block;
  text-align: center;
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.more {
  padding: 10px 0;
  text-align: center;
  font-size: 15px;
  border: 1px solid #E3E3E3;
  box-shadow: 0 3px 3px #E3E3E3;
  color: orange;
  border-radius: 10px;
}</style>



// WEBPACK FOOTER //
// src/pages/offline/serverList.vue